const BUCKET_NAME = 'users';

export default class ThingOwnerController {
    /** @ngInject */
    constructor(EventEmitter, AuthUsersApi) {
        this.eventEmitter = EventEmitter;
        this.AuthUsersApi = AuthUsersApi;
    }

    $onInit() {
        this.users = [];
        this.query = '';
        this.filterSelected = true;
        this.pendingSearch = null;
        this.lastSearch = 0;
        this.defaulImageUrl = '/assets/images/avatar.png';
        this.autocompleteRequireMatch = true;
        this.blurTime = 300;
    }

    $onChanges(changes) {
        if (changes.reset) {
            if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                this.resetValues();
            }
        }
    }

    transformChip(chip) { // eslint-disable-line class-methods-use-this
        // If it is an object, it's already a known chip
        if (typeof chip === 'object') {
            return chip;
        }

        // Otherwise, create a new one
        return { name: chip, type: 'new' };
    }

    searchUsers(criteria) {
        if (!this.pendingSearch || !this.debounceSearch()) {
            this.cancelSearch();

            this.pendingSearch = this.AuthUsersApi.search(criteria).then((response) => {
                let data = [];

                if (response && response.objects && response.objects.length) {
                    data = response.objects;
                }

                data = data.map((user) => {
                    if (!('first_name' in user) || !('last_name' in user)) {
                        user.fullName = 'NoNaMe';
                    } else {
                        user.fullName = `${user.first_name} ${user.last_name}`;
                    }
                    if (!user.image) {
                        user.image = this.defaulImageUrl;
                    }

                    return user;
                });

                data = data.filter((user) => {
                    let result = true;
                    const length = this.users.length;

                    if (!length) return result;

                    for (let i = 0; i < length; i++) {
                        if (this.users[i].id === user.id) {
                            result = false;
                            break;
                        }
                    }

                    return result;
                });

                this.refreshDebounce();

                return data;
            },
            this.refreshDebounce);
        }

        return this.pendingSearch;
    }

    refreshDebounce() {
        this.lastSearch = 0;
        this.pendingSearch = null;
    }

    cancelSearch() {
        if (this.pendingSearch) this.pendingSearch.reject();
    }

    /**
     * Debounce if querying faster than 300ms
     */
    debounceSearch() {
        const now = new Date().getMilliseconds();

        this.lastSearch = this.lastSearch || now;

        return ((now - this.lastSearch) < 300);
    }

    onChange() {
        const thingOwners = this.getThingOwners();

        if (thingOwners.length) {
            this.fillBucket(thingOwners);

            this.pushUpdate(
                this.eventEmitter({
                    value: thingOwners
                })
            );
        } else {
            this.clearBucket();
        }
    }

    getThingOwners() {
        const thingOwners = [];

        this.users.forEach((user) => {
            thingOwners.push(user.id);
        });

        return thingOwners;
    }

    fillBucket(value) {
        this.addItemToBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: value || this.getThingOwners()
                }
            })
        );
    }

    clearBucket() {
        this.removeItemFromBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            })
        );
    }

    resetValues() {
        this.users = [];

        this.clearBucket();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-owner/thing-owner.controller.js